import React, { useEffect, useState } from 'react'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import OtherService from '../services/Other'
import { Card, Col, Container, Row } from 'react-bootstrap'
import Loader from '../component/Loader'
import DOMPurify from "dompurify";
import { parseSafeHtml } from "../utils/safeHtmlParser";

const UserGuide = () => {
    const[isUseGuideData,setIsUseGuideData]=useState("")
    const[isNoData,setIsNoData]=useState(false)
    const [loading, setLoading] = useState(true);
    useEffect(() => {
      const userGuideDataFetch = async () => {
          try {
              const token = localStorage.getItem('access_token');
              const responseUserGuide = await OtherService.userGuideData();
  
              let rawHTML = responseUserGuide.data.content_banner_details_contact.content_spot_contents[0].article_detail;
  
              const parser = new DOMParser();
              const doc = parser.parseFromString(rawHTML, "text/html");
  
              const cleanHTML = DOMPurify.sanitize(doc.body.innerHTML);
  
              setIsUseGuideData(cleanHTML);
              setLoading(false);
          } catch (e) {
              console.error("e");
              setLoading(false);
          }
      };
      userGuideDataFetch();
  }, []);
  
    return (
        <>
        {loading && <Loader/> }
        
        <BreadCrumbSecttion
         pageTitle="User Guide"
         currentPageName="User Guide"/>
        <section className='padTop50'>
           <div className="dashboard-detail
s">
            <Container>
              <Row>
                    <Col xs={12}>
                        <section className='padTop50'>
                            <div className="userInfoBox">

                              <Card className="p-3">
                                <h4>User Guide</h4>
                                {/* <div
                                  dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize(`<p>${isUseGuideData}</p>`),
                                  }}
                                  ></div> */}
                                  <div>
                                    {parseSafeHtml(isUseGuideData)}
                                  </div>

                              </Card>
                            </div>
                        </section>
                    </Col>
                </Row>
                </Container>
           </div>
        </section>
       
        </>
      )
    }
    

export default UserGuide